import { Route, Routes } from "react-router-dom";
import "./App.css";
import MainPage from "./Home/MainPage";
import ProductList from "./Products/ProductList";
import { useEffect, useState } from "react";
import Loading from "./Loading/Loading";
import ProductView from "./Products/ProductView";
import Appbar from "./AppBar/Appbar";
import Footer from "./Footer/Footer";
import { doc, getDoc, increment, setDoc } from "firebase/firestore";
import { db } from "./Config/Config";
function App() {
   const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFooter();
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500); 
    return () => clearTimeout(timer);
  }, []);
     const [footerData,setfooterData] = useState(null);
      const fetchFooter = async ()=>{
          const visited = localStorage.getItem("visited");
          try {
          if(!visited){
          await setDoc(doc(db, "website-analytics", "visits"), {
            visits: increment(1)
          }, { merge: true });
          localStorage.setItem("visited", "true");
        }
          const docRef = doc(db, "website-data", "footer");
          const snapshot = await getDoc(docRef);
          setfooterData({...snapshot.data()});
          
          } catch(error){
            console.error("Error fetching footer data:", error);
      }
    }

  if (loading) {
    return (
   <>
   <Loading />
   </>
    );
  }
  return (
    <div>
            <Appbar />

    <Routes>
    <Route path="/" element={<MainPage />} />
    <Route path="/products" element={<ProductList />} />
    <Route path="/products-view" element={<ProductView />} />
    </Routes>
            <Footer footerData={footerData}/>

    </div>
  );
}

export default App;
